import { render, staticRenderFns } from "./BackgroundBanner.vue?vue&type=template&id=640d4996&scoped=true&"
import script from "./BackgroundBanner.vue?vue&type=script&lang=js&"
export * from "./BackgroundBanner.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundBanner.vue?vue&type=style&index=0&id=640d4996&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d4996",
  null
  
)

export default component.exports